/* eslint-disable max-len */
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledIcon = styled.svg`
	width: 24px;
	height: 24px;
	fill: #21ba72;
	min-height: 24px;
	min-width: 24px;
	margin-right: 4px;
`

export const PointIcon: FC<React.HTMLAttributes<unknown>> = () => (
	<StyledIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="12" cy="12.0005" r="3" />
	</StyledIcon>
)
